import { RouterModule, Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { HelpDocsResolver } from './shared/help-docs.resolver';
import { HelpDocComponent } from '../core/component/help-doc/help-doc.component';

const helpDocsRoutes: Routes = [ 
     {
            path: 'help-docs',
            component: HelpDocComponent,
            data: { tab: 'Help-Docs' },
            resolve: {
                        tabData: HelpDocsResolver
                    },
             children: [
                        
                         {
                             path: 'data/:tabid',
                             component: HelpDocComponent,
                             data: { tab: 'Help-Docs' },
                             resolve: {
                                 tabData: HelpDocsResolver
                             }
                         }]
    
        }
];

/**
 * @export
 * @class LocoRoutingModule
 */
@NgModule({
    imports: [
        RouterModule.forChild(helpDocsRoutes)
    ],
    exports: [
        RouterModule
    ]
})
export class HelpDocsRoutingModule {

}
